import { Dispatch } from "redux";
import {LoginService} from "../../services/LoginService";
import {passwordapi,fundmanagerapi,donorapi,mobileapi} from"../../ApiNames";


export const fetchDataSuccess=(data:any) =>({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});
export const fetchdashDataSuccess=(dashdata:any) =>({
    type: 'FETCH_DASH_DATA_SUCCESS',
    payload: dashdata,
});
export const fetchPieChartDataSuccess = (pieChartData: any,piechartOptions: any) => ({
    type: 'FETCH_PIE_CHART_DATA_SUCCESS',
    payload: {pieChartData,piechartOptions}
});
export const fetchOrgChartDataSuccess = (orgChartData: any,orgchartOptions:any) => ({
    type: 'FETCH_ORGANISATION_CHART_DATA_SUCCESS',
    payload: {orgChartData,orgchartOptions}
});
export const fetchfundPieChartDataSuccess = (fundpieChartData: any,fundpiechartOptions:any) => ({
    type: 'FETCH_FUND_CHART_DATA_SUCCESS',
    payload: {fundpieChartData,fundpiechartOptions}
});export const fetchfundDonorChartDataSuccess = (funChartData: any,funchartOptions:any) => ({
    type: 'FETCH_FUN_BAR_DATA_SUCCESS',
    payload: {funChartData,funchartOptions}
});
// export const fetchTableDataSuccess = (tableData: any) => ({
//     type: 'FETCH_Table_CHART_DATA_SUCCESS',
//     payload: {tableData}
// });
export const fetchdonPieChartDataSuccess = (donpieChartData: any,donpiechartOptions: any) => ({
    type: 'FETCH_DONOR_PIE_CHART_DATA_SUCCESS',
    payload: {donpieChartData,donpiechartOptions}
});

export const fetchDonorChartDataSuccess = (donorChartData: any,donorrchartOptions:any) => ({
    type: 'FETCH_Donor_CHART_DATA_SUCCESS',
    payload: {donorChartData,donorrchartOptions}
});
export const fetchData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {userid:uid };
            const apiname = mobileapi.mobapp;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchdashData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {userid:uid };
            const apiname = mobileapi.mobdash;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchdashDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
//To get pie chart data
export const fetchPieChartData = (uid:any) => {
    return async (dispatch: Dispatch) => {
            try {
                const payload = { q: 3,userid:uid };
                const apiname = mobileapi.mobcol;
                const response = await LoginService.getData(apiname,payload)
                if (Array.isArray(response) && response.length > 0) {
                    const documentStyle = getComputedStyle(document.documentElement);
                    const labels = response.map(item => item.label); 
                    const values = response.map(item => item.value);
                    const data = {
                        // labels: ['A', 'B', 'C'],
                        labels: labels,
                        datasets: [
                            {
                               // data: response
                               data: values
                            }
                        ]
                    }
                    const options = {
                        plugins: {
                            legend: {
                                labels: {
                                    usePointStyle: true
                                }
                            }
                        }
                    };
                    dispatch(fetchPieChartDataSuccess(data, options));
                }
            } catch (error) {
                console.error('Error fetching chart data:', error);
            }
    };
};
//To get bar chart data
export const fetchChartData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { q: 4 ,userid:uid};
            const apiname = mobileapi.mobcol;
            const response = await LoginService.getData(apiname,payload)
            if (Array.isArray(response) && response.length > 0) {
              const labels = response.map(item => item.label); 
              const values = response.map(item => item.value);
              console.log("values",values)
              const data = {
                labels: labels,
                datasets: [
                  {
                    label:'Members',
                    data: 
                      values
                    ,
                    backgroundColor: [
                      'rgba(255, 159, 64, 0.2)',
                      'rgba(75, 192, 192, 0.2)',
                      'rgba(54, 162, 235, 0.2)',
                      'rgba(153, 102, 255, 0.2)',
                    ],
                    borderColor: [
                      'rgb(255, 159, 64)',
                      'rgb(75, 192, 192)',
                      'rgb(54, 162, 235)',
                      'rgb(153, 102, 255)',
                    ],
                    borderWidth: 1,
                  },
                ],
              };
              const options = {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                },
              };
              dispatch(fetchOrgChartDataSuccess(data, options));
            }
          } catch (error) {
            console.error('Error fetching chart data:', error);
          }

    };
};
// export const fetchTableData = (uid:any) => {
//     return async (dispatch: Dispatch) => {
//         try {
//             const payload = { uid:uid,q:2 };
//             const apiname = passwordapi.moblist;
//             const response = await LoginService.getData(apiname,payload)
//             dispatch(fetchTableDataSuccess(response));
//         } catch (error) {
//             console.error('Error fetching data:', error);
//         }
//     };
// };
export const fetchfundPieChartData = (uid:any) => {
    return async (dispatch: Dispatch) => {
            try {
                const payload = { userid:uid,q: 5 };
                const apiname = fundmanagerapi.fmcharts;
                const response = await LoginService.getData(apiname,payload)
                if (Array.isArray(response) && response.length > 0) {
                    const documentStyle = getComputedStyle(document.documentElement);
                    const labels = response.map(item => item.label); 
                    const values = response.map(item => item.value);
                    const data = {
                        // labels: ['A', 'B', 'C'],
                        labels: labels,
                        datasets: [
                            {
                               // data: response
                               data: values
                            }
                        ]
                    }
                    const options = {
                        plugins: {
                            legend: {
                                labels: {
                                    usePointStyle: true
                                }
                            }
                        }
                    };
                    dispatch(fetchfundPieChartDataSuccess(data, options));
                }
            } catch (error) {
                console.error('Error fetching chart data:', error);
            }
    };
};
//To get bar chart data
export const fetchfundDonorChartData = (uid:any) => {

    return async (dispatch: Dispatch) => {
        //console.log(Dispatch);
        try {
            const payload = {userid:uid, q: 6 };
            const apiname = fundmanagerapi.fmcharts;
            const response = await LoginService.getData(apiname,payload)
            if (Array.isArray(response) && response.length > 0) {
              const labels = response.map(item => item.label); 
              const values = response.map(item => item.value);
              const data = {
                labels: labels,
                datasets: [
                  {
                    label:'Members',
                    data: 
                      values
                    ,
                    backgroundColor: [
                      'rgba(255, 159, 64, 0.2)',
                      'rgba(75, 192, 192, 0.2)',
                      'rgba(54, 162, 235, 0.2)',
                      'rgba(153, 102, 255, 0.2)',
                    ],
                    borderColor: [
                      'rgb(255, 159, 64)',
                      'rgb(75, 192, 192)',
                      'rgb(54, 162, 235)',
                      'rgb(153, 102, 255)',
                    ],
                    borderWidth: 1,
                  },
                ],
              };
              const options = {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                },
              };
              dispatch(fetchfundDonorChartDataSuccess(data, options));
            }
          } catch (error) {
            console.error('Error fetching chart data:', error);
          }

    };
};
export const fetchdonPieChartData = () => {
    return async (dispatch: Dispatch) => {
            try {
                const payload = { q: 7 };
                const apiname = donorapi.dcharts;
                const response = await LoginService.getData(apiname,payload)
                if (Array.isArray(response) && response.length > 0) {
                    const documentStyle = getComputedStyle(document.documentElement);
                    const labels = response.map(item => item.label); 
                    const values = response.map(item => item.value);
                    const data = {
                        // labels: ['A', 'B', 'C'],
                        labels: labels,
                        datasets: [
                            {
                               // data: response
                               data: values
                            }
                        ]
                    }
                    const options = {
                        plugins: {
                            legend: {
                                labels: {
                                    usePointStyle: true
                                }
                            }
                        }
                    };
                    dispatch(fetchdonPieChartDataSuccess(data, options));
                }
            } catch (error) {
                console.error('Error fetching chart data:', error);
            }
    };
};
//To get bar chart data
export const fetchDonorChartData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { q: 8 ,userid:uid};
            const apiname = donorapi.dcharts;
            const response = await LoginService.getData(apiname,payload)
            if (Array.isArray(response) && response.length > 0) {
              const labels = response.map(item => item.label); 
              const values = response.map(item => item.value);
              const data = {
                labels: labels,
                datasets: [
                  {
                    label:'Months',
                    data: 
                      values
                    ,
                    backgroundColor: [
                      'rgba(255, 159, 64, 0.2)',
                      'rgba(75, 192, 192, 0.2)',
                      'rgba(54, 162, 235, 0.2)',
                      'rgba(153, 102, 255, 0.2)',
                    ],
                    borderColor: [
                      'rgb(255, 159, 64)',
                      'rgb(75, 192, 192)',
                      'rgb(54, 162, 235)',
                      'rgb(153, 102, 255)',
                    ],
                    borderWidth: 1,
                  },
                ],
              };
              const options = {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                },
              };
              dispatch(fetchDonorChartDataSuccess(data, options));
            }
          } catch (error) {
            console.error('Error fetching chart data:', error);
          }

    };
};


